/**
 * Effet de scintillement au clic de souris
 * Pour le thème Shopify "La Magie de Mathilde"
 */

document.addEventListener('DOMContentLoaded', function() {
  let isMousePressed = false;
  let sparkleInterval = null;
  let currentMouseX = 0;
  let currentMouseY = 0;
  let particleCounter = 0;
  let lastMouseMoveTime = 0;
  let mouseMoveThrottle = 40; // Délai en ms entre les étoiles de mouvement (réduit pour plus d'étoiles)
  let mouseTrail = []; // Historique des positions pour la traînée
  
  // Créer l'étoile rotative du curseur
  const cursorStar = document.createElement('div');
  cursorStar.className = 'rotating-cursor-star';
  cursorStar.innerHTML = `
    <svg viewBox="0 0 24 24" fill="#FFD700" style="width: 100%; height: 100%; filter: drop-shadow(0 0 3px #FFD700);">
      <path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z"/>
    </svg>
  `;
  cursorStar.style.display = 'none'; // Caché par défaut
  document.body.appendChild(cursorStar);
  
  // Fonction pour créer une étoile scintillante
  function createSparkle(x, y, index, isSmall = false) {
    const sparkle = document.createElement('div');
    sparkle.className = 'sparkle-particle';
    
    // Position aléatoire autour du curseur
    const offsetRange = isSmall ? 30 : 60; // Réduire la zone pour les petites étoiles
    const offsetX = (Math.random() - 0.5) * offsetRange;
    const offsetY = (Math.random() - 0.5) * offsetRange;
    
    sparkle.style.left = (x + offsetX) + 'px';
    sparkle.style.top = (y + offsetY) + 'px';
    
    // Tailles différentes selon le type d'étoile
    let size;
    if (isSmall) {
      // Petites étoiles pour le mouvement de la souris
      size = Math.random() * 4 + 2;
    } else {
      // Étoiles normales pour les clics
      const isLarge = index % 3 === 0;
      size = isLarge ? Math.random() * 12 + 10 : Math.random() * 8 + 4;
    }
    
    sparkle.style.width = (size * 2) + 'px';
    sparkle.style.height = (size * 2) + 'px';
    
    // Couleurs - nuances de jaune uniquement
    const colors = ['#FFD700', '#FFF700', '#FFED4E', '#FFC107', '#FFB300', '#FFDB58'];
    const color = colors[Math.floor(Math.random() * colors.length)];
    
    // Créer une étoile SVG
    sparkle.innerHTML = `
      <svg viewBox="0 0 24 24" fill="${color}" style="width: 100%; height: 100%; filter: drop-shadow(0 0 ${size/2}px ${color})">
        <path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z"/>
      </svg>
    `;
    
    // Animation adaptée à la taille
    const duration = isSmall ? 
      Math.random() * 0.4 + 0.6 : // Durée plus courte pour les petites étoiles
      Math.random() * 0.8 + 1.2;  // Durée normale pour les grandes étoiles
    sparkle.style.animationDuration = duration + 's';
    
    document.body.appendChild(sparkle);
    
    // Supprimer la particule après l'animation
    setTimeout(() => {
      sparkle.remove();
    }, duration * 1000);
  }
  
  // Fonction pour générer des étoiles en continu
  function startSparkleGeneration() {
    if (sparkleInterval) return; // Éviter les doublons
    
    sparkleInterval = setInterval(() => {
      if (isMousePressed) {
        // Créer 4-7 particules à chaque intervalle (augmenté)
        const particleCount = Math.floor(Math.random() * 4) + 4;
        
        for (let i = 0; i < particleCount; i++) {
          createSparkle(currentMouseX, currentMouseY, particleCounter++);
        }
      }
    }, 50); // Générer des étoiles toutes les 50ms (réduit de 80ms)
  }
  
  // Fonction pour arrêter la génération d'étoiles
  function stopSparkleGeneration() {
    if (sparkleInterval) {
      clearInterval(sparkleInterval);
      sparkleInterval = null;
    }
  }
  
  // Suivre la position de la souris et créer de petites étoiles
  document.addEventListener('mousemove', function(e) {
    currentMouseX = e.pageX;
    currentMouseY = e.pageY;
    
    // Mettre à jour la position de l'étoile rotative (utiliser clientX/Y pour position fixe)
    cursorStar.style.left = (e.clientX - 12) + 'px'; // Centrer l'étoile (20px/2 = 10px)
    cursorStar.style.top = (e.clientY - 20) + 'px';
    cursorStar.style.display = 'block';
    
    // Ajouter la position actuelle à la traînée
    mouseTrail.push({ x: e.pageX, y: e.pageY, time: Date.now() });
    
    // Nettoyer les positions trop anciennes (plus de 200ms)
    const now = Date.now();
    mouseTrail = mouseTrail.filter(pos => now - pos.time < 100);
    
    // Créer de petites étoiles lors du mouvement (avec throttling)
    if (now - lastMouseMoveTime > mouseMoveThrottle && !isMousePressed) {
      lastMouseMoveTime = now;
      
      // Créer 2-4 petites étoiles (augmenté)
      const smallParticleCount = Math.floor(Math.random() * 8) + 2;
      
      for (let i = 0; i < smallParticleCount; i++) {
        setTimeout(() => {
          // Utiliser une position de la traînée pour un effet de suivi
          const trailIndex = Math.min(i * 2, mouseTrail.length - 1);
          const trailPos = mouseTrail[trailIndex] || { x: e.pageX, y: e.pageY };
          
          createSparkle(trailPos.x, trailPos.y, i, true); // true = petite étoile
        }, i * 8); // Légèrement réduit pour plus de fluidité
      }
    }
  });
  
  // Gestionnaire mousedown - commencer l'effet
  document.addEventListener('mousedown', function(e) {
    isMousePressed = true;
    currentMouseX = e.pageX;
    currentMouseY = e.pageY;
    particleCounter = 0;
    
    // Créer un premier burst d'étoiles immédiatement (plus important)
    const initialParticleCount = Math.floor(Math.random() * 8) + 10;
    for (let i = 0; i < initialParticleCount; i++) {
      setTimeout(() => {
        createSparkle(e.pageX, e.pageY, i);
      }, i * 3); // Encore plus rapide pour un effet plus spectaculaire
    }
    
    // Commencer la génération continue
    startSparkleGeneration();
  });
  
  // Gestionnaire mouseup - arrêter l'effet
  document.addEventListener('mouseup', function(e) {
    isMousePressed = false;
    stopSparkleGeneration();
  });
  
  // Arrêter l'effet si la souris quitte la fenêtre
  document.addEventListener('mouseleave', function(e) {
    isMousePressed = false;
    stopSparkleGeneration();
    cursorStar.style.display = 'none'; // Cacher l'étoile du curseur
  });
});